/* Free-gift cart guard.

   The Hair Grow LP (/pages/hair-grow) adds two $30 gift variants to the cart
   alongside the 90-day subscription, and the "Hair Grow 90-Day Plan: 2 Free
   Gifts" automatic discount zeroes them. Shopify has no server-side link
   between those lines: remove the subscription and the gifts stay behind,
   still discounted to $0. This sweeps orphaned gift lines out whenever the
   cart changes, and once on page load so carts orphaned in an earlier
   session are cleaned up too. */
(function () {
  'use strict';

  /* Keep in step with OFFERS.sub.gifts in hair-grow.js and the variant list on
     the automatic discount. */
  var GIFT_VARIANTS = [67625775562979, 67625775628515];
  /* Hair Grow Bites - 3 Month Delivery. The line that earns the gifts. */
  var REQUIRED_VARIANTS = [46582099214563];

  var sweeping = false;

  function orphans(cart) {
    if (!cart || !cart.items || !cart.items.length) return [];
    var earned = cart.items.some(function (i) {
      return REQUIRED_VARIANTS.indexOf(i.id) !== -1;
    });
    if (earned) return [];
    return cart.items.filter(function (i) {
      return GIFT_VARIANTS.indexOf(i.id) !== -1;
    });
  }

  function setBubbles(n) {
    ['#cart-icon-bubble .cart-bubble',
     '#cart-icon-bubble--mobile .cart-bubble',
     '.cart-drawer__item-count'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.innerText = n;
    });
  }

  function sweep(cart) {
    if (sweeping) return;
    var dead = orphans(cart);
    if (!dead.length) return;
    sweeping = true;

    var updates = {};
    dead.forEach(function (i) { updates[i.id] = 0; });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        /* Removing the subscription usually leaves nothing but the gifts, so
           the common case is an emptied cart. Neither onCartUpdate() branch
           renders the empty state - they only swap the line-item markup - so
           a reload is the only way to get the right chrome. On /cart that
           reads as an ordinary removal. */
        if (state.item_count === 0) { window.location.reload(); return; }
        setBubbles(state.item_count);
        /* Any source other than "cart-items" makes the theme's CartItems and
           CartDrawerItems re-fetch their section and repaint themselves. */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-guard', cartData: state });
        }
      })
      .catch(function () { /* leave it; checkout re-evaluates the discount */ })
      .finally(function () { sweeping = false; });
  }

  function sweepFromServer() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sweep)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweepFromServer);
  } else {
    sweepFromServer();
  }

  /* Trigger on the network call rather than on PUB_SUB_EVENTS.cartUpdate.
     cart.js only publishes AFTER its repaint loop, and that loop throws
     whenever one of its sections is absent from the page - getSectionsToRender
     lists cart-icon-bubble--mobile, which does not exist everywhere - so the
     publish is silently skipped on exactly the removal we care about. Watching
     the request itself is independent of whether the theme gets that far.

     The delay lets the theme finish its own repaint first, so we are not
     racing it with a cart state it is about to overwrite. */
  var CART_WRITE = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/;
  try {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) { /* exotic Request object; just skip the check */ }
      var pending = nativeFetch.apply(this, arguments);
      if (url && CART_WRITE.test(url) && !sweeping) {
        pending.then(function () {
          setTimeout(sweepFromServer, 350);
        }, function () {});
      }
      /* Always hand back the original promise: the theme's own chain, and its
         error handling, must be completely unaffected by this hook. */
      return pending;
    };
  } catch (e) { /* leave fetch alone; the load-time sweep still runs */ }

  /* Secondary trigger for anything that mutates the cart without fetch. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'gift-guard') return;
      if (event.cartData && event.cartData.items) { sweep(event.cartData); return; }
      sweepFromServer();
    });
  }
})();
